import { useTheme } from 'src/providers/ThemeProvider';

export type ChartThemeMode = 'light' | 'dark';

export const CHART_SERIES: Record<ChartThemeMode, string[]> = {
  light: ['#2F3A8B', '#36A9E1', '#66C5DB', '#E0A100', '#8A94A6', '#D9433A', '#5436AF', '#C24BB5'],
  dark: ['#4A58C4', '#4FB8E8', '#66C5DB', '#F2B935', '#8A94A6', '#F07068', '#A08CE8', '#E08AD6'],
};

export const CHART_NEUTRAL: Record<ChartThemeMode, string> = { light: '#E4E8EE', dark: '#2A2B35' };
export const CHART_GRID: Record<ChartThemeMode, string> = {
  light: 'rgba(0, 1, 30, 0.08)',
  dark: 'rgba(255, 255, 255, 0.1)',
};
export const CHART_SUCCESS: Record<ChartThemeMode, string> = { light: '#1E9E6A', dark: '#3DBE8C' };
export const CHART_ERROR: Record<ChartThemeMode, string> = { light: '#D9433A', dark: '#F07068' };
export const CHART_TICK = '#8A94A6';

export const chartMode = (theme?: string): ChartThemeMode => (theme === 'dark' ? 'dark' : 'light');

export const chartSeries = (theme?: string): string[] => CHART_SERIES[chartMode(theme)];

export const useChartTheme = () => {
  const { theme } = useTheme();
  const mode = chartMode(theme);
  return {
    mode,
    series: CHART_SERIES[mode],
    neutral: CHART_NEUTRAL[mode],
    grid: CHART_GRID[mode],
    success: CHART_SUCCESS[mode],
    error: CHART_ERROR[mode],
    tick: CHART_TICK,
  };
};
